import { InfoType } from '@axo/shared/ui/input/lib/InputInfoBox/InputInfoBox.types';
import { useFormState } from 'react-hook-form';

interface Props {
  name: string;
  hasFocus?: boolean;
  infoBoxType?: InfoType;
  isValidating?: boolean;
  disableSuccessState?: boolean;
  valid?: boolean;
}

export const usePrimaryState = ({
  hasFocus,
  name,
  isValidating,
  infoBoxType,
  disableSuccessState = false,
  valid = false,
}: Props) => {
  const { dirtyFields, touchedFields } = useFormState();
  const isDirty = dirtyFields[name];
  const isTouched = touchedFields[name];

  if (isValidating) {
    return 'loading';
  }

  if (infoBoxType === InfoType.ERROR) return 'invalid';

  if (infoBoxType === InfoType.WARNING) return 'soft-invalid';

  if (disableSuccessState) return 'undetermined';

  if (infoBoxType === InfoType.SUCCESS) return 'valid';

  if (!hasFocus && (isDirty || isTouched)) return 'valid';

  if (valid) return 'valid';

  if (infoBoxType === InfoType.TOOLTIP) return 'undetermined-with-tooltip';

  return 'undetermined';
};
